import { render, staticRenderFns } from "./CarTireDiagram.vue?vue&type=template&id=2c574589&scoped=true&"
import script from "./CarTireDiagram.vue?vue&type=script&lang=js&"
export * from "./CarTireDiagram.vue?vue&type=script&lang=js&"
import style0 from "./CarTireDiagram.vue?vue&type=style&index=0&id=2c574589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c574589",
  null
  
)

export default component.exports